import { render } from "./FooterMain.vue?vue&type=template&id=5ac676fd"
const script = {}

import "./FooterMain.vue?vue&type=style&index=0&id=5ac676fd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__